import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNearMeDisabled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_4812_12930)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M12.0005 6.3399L21.0005 2.9999L17.6605 11.9999L16.1005 10.4399L17.6005 6.3899L13.5505 7.8899L12.0005 6.3399ZM21.1905 21.1899L16.1205 16.1199L14.3105 20.9999H12.9005L10.0705 13.9299L3.00055 11.0999V9.6899L7.88055 7.8799L2.81055 2.8099L4.22055 1.3999L22.6005 19.7799L21.1905 21.1899ZM14.5705 14.5699L9.43055 9.4299L6.72055 10.4399L11.6105 12.3899L13.5605 17.2799L14.5705 14.5699Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4812_12930",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgNearMeDisabled;
